import validateMixins from "@/mixins/validateMixins";

export default {
    mixins: [validateMixins],
    data() {
        return {
        }
    },
    methods: {
        replyRule(value){
            if(this.isRequired(value)){
                return 'input_comment_reply'
            }
            return true
        },
        commentRule(value){
            if(this.isRequired(value)){
                return 'comment_reply'
            }
            return true
        }
    }
}
